export const isIos = () =>
  navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i);
export const isMobileDevice = () =>
  !!navigator.userAgent.match(/(iPhone|iPod|iPad|Android|BlackBerry)/);
export const isApple = () => !!navigator.userAgent.match(/Mac/i);

export default isMobileDevice;
